import React, { Component } from 'react';
import { Icon, Button } from 'ui';
import Popover from 'components/shared/popover';
import { routes } from 'constants/config';

const isIOS = () =>
  /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

const isAndroid = () => /(android)/i.test(navigator.userAgent);

const formatCalendarTime = dateStr => {
  const date = new Date(dateStr);
  return date.toISOString().replace(/-|:|\.\d+/g, '');
};

const videoConferenceText = (event, session) => {
  const eventsInProgress = session.video_meeting.provider === 'other';
  const meetingUrl = eventsInProgress
    ? `${document.location.origin}${routes.IN_PERSON_TRAINING.JOIN_MEETING(
        event.id,
        session.id,
      )}`
    : session.video_meeting.url;
  return t('in_person_training.calendar.video_conference', {
    url: meetingUrl,
  });
};

const descriptionText = event => {
  return event.description
    ? t('in_person_training.calendar.description', {
        description: event.description,
      })
    : '';
};

const calendarDescription = (event, session) => {
  const description = [];
  if (session.video_meeting) {
    description.push(videoConferenceText(event, session));
  }
  description.push(descriptionText(event));
  description.push(
    t('in_person_training.calendar.change_register', {
      link: document.URL,
    }),
  );
  return description.join('');
};

const getFormattedTimes = (event, session) => ({
  startTime: formatCalendarTime(event.start_time),
  endTime: formatCalendarTime(event.end_time),
});

const CalendarOption = ({ children, className, event }) => {
  return (
    <a
      className={`AddToCalendarLink ${className}`}
      href={routes.TRAINING.ICS_DOWNLOAD(event.id)}
      download
    >
      {children}
    </a>
  );
};

const getGoogleLink = (event, session) => {
  const { startTime, endTime } = getFormattedTimes(session);
  return `https://www.google.com/calendar/render\
?action=TEMPLATE\
&text=${encodeURIComponent(event.name || '')}\
&dates=${encodeURIComponent(startTime || '')}/\
${encodeURIComponent(endTime || '')}\
&details=${encodeURIComponent(calendarDescription(event, session))}\
&location=${encodeURIComponent(session.location || '')}`;
};

const GoogleCalendarOption = ({ className, event, session, web }) => {
  return (
    <a
      className={`AddToCalendarLink ${className}`}
      target="_blank"
      rel="noopener noreferrer"
      href={getGoogleLink(event, session)}
    >
      <Icon name="google" className="mr-4" />
      {web
        ? t('in_person_training.calendar.add_to_google_web')
        : t('in_person_training.calendar.add_to_google')}
    </a>
  );
};

class AddToCalendar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
    };
    this.togglePopover = this.togglePopover.bind(this);
  }

  togglePopover() {
    const { active } = this.state;
    this.setState({
      active: !active,
    });
  }

  render() {
    const { event, session } = this.props;
    const { active } = this.state;
    const isDesktop = () => !isIOS() && !isAndroid();

    return (
      <div className="pos-r AddToCalendarDiv">
        <Button
          url={routes.TRAINING.ICS_DOWNLOAD(event.id)}
          className="AddToCalendarButton"
          onMouseDown={e => {
            // Prevents mouse click focus ring
            e.preventDefault();
          }}
        >
          {t('in_person_training.events.add_to_calendar')}
        </Button>

        {active && (
          <Popover
            styleName="AddToCalendarPopover"
            dismissCallback={this.togglePopover}
          >
            {isIOS() && (
              <>
                <GoogleCalendarOption
                  className="mb-4"
                  event={event}
                  session={session}
                  web
                />
                <CalendarOption className="mb-4" event={event}>
                  <Icon name="apple" className="mr-4" />
                  {t('in_person_training.calendar.add_to_ical')}
                </CalendarOption>
              </>
            )}
            {isAndroid() && (
              <>
                <GoogleCalendarOption
                  className="mb-4"
                  event={event}
                  session={session}
                  web
                />
                <CalendarOption className="mb-4" event={event}>
                  <Icon name="calendar" className="mr-4" />
                  {t('in_person_training.calendar.add_to_general')}
                </CalendarOption>
              </>
            )}
            {isDesktop() && (
              <>
                <GoogleCalendarOption
                  className="mb-4"
                  event={event}
                  session={session}
                />
                <CalendarOption className="mb-4" event={event}>
                  <Icon name="microsoft" className="mr-4" />
                  {t('in_person_training.calendar.add_to_outlook')}
                </CalendarOption>
                <CalendarOption className="mb-4" event={event}>
                  <Icon name="apple" className="mr-4" />
                  {t('in_person_training.calendar.add_to_ical')}
                </CalendarOption>
              </>
            )}
          </Popover>
        )}
      </div>
    );
  }
}

export default AddToCalendar;
